var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',_vm._g({staticClass:"tip-icon",attrs:{"font-size":_vm.fontSize,"color":_vm.color}},_vm.$listeners),[_vm._v(" sci-tip ")])}
var staticRenderFns = []

export { render, staticRenderFns }